@import "../../../../../styles/variables";
@import "node_modules/@se/web-ui/styles/_se-variable";

:host {
  display: block;
  --se-success: #008a16;
}

.ftn-header-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  padding: 8px 16px;
  border-top: 1px solid $svs-super-light-grey;
  background-color: $svs-white;

  &.has-selected {
    padding: 16px;
  }

  .ftn-info-wrapper {
    display: flex;
    flex-direction: column;

    .ftn-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;

      &:first-letter {
        text-transform: uppercase;
      }
    }

    .ftn-selected-list {
      margin-top: 4px;
      overflow: hidden;
      max-height: 40px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &.opened {
    border-bottom: 1px solid $svs-super-light-grey;
  }

  &.buttons-wrapper {
  }
}

.ftn-content-wrapper {
  display: none;
  background-color: $svs-100-background;
  padding: 8px 0;
  overflow-y: scroll;

  &.visible {
    display: block;
  }

  .ftn-filters-input {
    display: block;
    position: relative;
    margin: 8px 16px 8px 16px;

    .ftn-input {
      display: block;
    }
  }

  .ftn-checkbox-list-wrapper {
    .filtered-hide {
      display: none;
    }
  }
}

.ffn-header-label-wraper {
  display: flex;
  align-items: center;
}
